<form id="busy-form" action="#" method="POST" soho-busyindicator soho-busyindicator
    [transparentOverlay]="transparentOverlay" [blockUI]="true" [text]="message" [displayDelay]="delay"
    autocomplete="off">
    <div id="notification">
    </div>
    <div class="row" style="padding-top:1%; padding-left:1%;">
        <h2 class="fieldset-title" style="font-size: x-large;">{{ProjectTitle}}</h2>
    </div>
    <div class="row">
        <div class="twelve columns">
            <div class="six columns" style="padding-left: 4%;padding-top: 3%;">
                <div class="row top-padding">
                    <div class="field">
                        <label id="tblstaffid" class="required" for="staffid">HMD ID</label>
                        <input id="staffid" name="staffid" type="number" data-validate="required" soho-input placeholder="111000"
                            (click)="RemoveError('staffid')" [(ngModel)]="model.staffid" />
                    </div>
                </div>
                <div class="field">
                    <label id="tblsecurityroleid" class="required" for="securityroleid">Access
                        Type</label>
                    <select id="securityroleid" soho-dropdown name="securityroleid"
                        (click)="RemoveError('securityroleid')" [(ngModel)]="model.securityroleid">
                        <option value="-1" selected="">--Select--</option>
                        <option value="10001" selected="">ADMIN</option>
                        <option value="10002" selected="">FINANCE</option>  
                    </select>
                </div>
                <div class="field ">
                    <label id="tblemailaddress" class="required" for="emailaddress">User Email Id</label>
                    <input id="emailaddress" name="emailaddress" type="text" data-validate="required"
                        placeholder="someone@someplace.com" (click)="RemoveError('emailaddress')"
                        [(ngModel)]="model.emailaddress" />
                </div>
                <div class="row" id="UploadDetails" style="text-align: center;padding-top: 2%;">
                    <button class="btn-primary hide-focus" type="button" (click)="UploadDetails()">Save Detailes</button>&nbsp;
                </div>
            </div>
        </div>
    </div>
   
</form>

